export default function retrieveToken(tokenNeeded: string) {
  if (tokenNeeded === "auth_token") return document.cookie.split("=")[1];
  if (tokenNeeded === "refresh_token") return localStorage.getItem("refresh_token");
}
